import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_collections } from '@/hooks/store/use_slices';
import { on_user_leave_from_entity, try_update_viewed_entity } from '@/utils/utils_client_workspace_child_entity_viewers';
import { DTO__collection } from '@shared/dto/collection/DTO__collection';
import { useRef } from 'react';

export function WatcherViewEntityCollection() {
  const { collection_current } = use_slice_collections(['collection_current']);

  const ref_entity = useRef(DTO__collection.CREATE_STUB());

  /*
   * EFFECTS
   */
  use_effect(() => {
    if (ref_entity.current._id == collection_current._id) return;

    ref_entity.current = collection_current;

    void try_update_viewed_entity(collection_current);

    return () => {
      if (ref_entity.current.is_stub()) return;

      void on_user_leave_from_entity(ref_entity.current._id, ref_entity.current.type);
    };
  }, [collection_current]);

  return <></>;
}
